import { Button, Card, Input, Select } from 'antd'
import { UserMeyRealSearchParams, UserMeyRealType } from 'Modules'
import { useCallback, useEffect, useState } from 'react'

import { AppAdmin } from 'api/app-admin'
import Breadcrumb from 'component/breadcrumb/breadcrumb'
import { BREADCRUMBS } from 'constants/breadcrumb'
import {
  USER_MEY_REAL_KYC_STATUS_OPTIONS,
  USER_MEY_REAL_STATUS_OPTIONS,
} from 'constants/user-mey-real'
import useSearchParams from 'hooks/use-search-params'
import ButtonExportUserMeyReal from 'modules/user-mey-real/button-export-user-mey-real'
import UserMeyRealOverview from 'modules/user-mey-real/overview'
import UserMeyRealTable from 'modules/user-mey-real/user-mey-real-table'
import { logError } from 'utils/logger'

import './style.scss'

const UserMeyReal = () => {
  const additionalItems = [BREADCRUMBS.USER_MEY_REAL]

  const { searchParams, initPagination, onSearch, onChangePagination } =
    useSearchParams<UserMeyRealSearchParams>({})

  const [data, setData] = useState<UserMeyRealType[]>([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)

  const getData = useCallback(async () => {
    setLoading(true)
    try {
      const res = await AppAdmin.getUserMeyRealList(searchParams)

      if (res?.data?.data) {
        setData(res.data.data.results || [])
        setTotal(res.data.data.totalResults || 0)
      }
    } catch (error) {
      logError('Error fetching data:', error)
      setData([])
      setTotal(0)
    } finally {
      setLoading(false)
    }
  }, [searchParams])

  useEffect(() => {
    getData()
  }, [getData])

  return (
    <div className="main-section user-mey-real">
      <Breadcrumb additionalItems={additionalItems} />
      <div className="main-title" style={{ marginBottom: 20 }}>
        User (Mey Real)
      </div>

      <UserMeyRealOverview />

      <Card className="user-mey-real-search" style={{ marginBottom: 16 }}>
        <div className="search-filters">
          <Input
            placeholder="Search by wallet address or email"
            value={searchParams.search || ''}
            onChange={(e) => onSearch({ search: e.target.value } as UserMeyRealSearchParams)}
            allowClear
          />
          <Select
            placeholder="All KYC Status"
            options={USER_MEY_REAL_KYC_STATUS_OPTIONS}
            value={searchParams.kycStatus ?? null}
            onChange={(value) => onSearch({ kycStatus: value } as UserMeyRealSearchParams)}
            style={{ width: 170 }}
          />
          <Select
            placeholder="All Status"
            options={USER_MEY_REAL_STATUS_OPTIONS}
            value={searchParams.status ?? null}
            onChange={(value) => onSearch({ status: value } as UserMeyRealSearchParams)}
            style={{ width: 140 }}
          />
          <Button type="primary" onClick={() => onSearch()}>
            Search
          </Button>
          <ButtonExportUserMeyReal searchParams={searchParams} />
        </div>
      </Card>

      <UserMeyRealTable
        data={data}
        loading={loading}
        pagination={initPagination(total)}
        onChange={onChangePagination}
        onRefresh={getData}
      />
    </div>
  )
}

export default UserMeyReal
